import {
  EEvolveLandingPageTabs,
  EWorkshopAndEventPageTabs,
  thunkActionLoading,
} from '@configs'
import { zodResolver } from '@hookform/resolvers/zod'
import {
  getEvolvePageSeoAction,
  updateEvolvePageSeoAction,
  useAppDispatch,
  useAppSelector,
} from '@redux'
import { Skeleton, message } from 'antd'
import { Fragment, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { Button } from 'src/common'
import { EMediaCategory } from 'src/interfaces/gallery'
import MetaTab from 'src/pages/blog/content/MetaTab'
import { IEventSeoSchema, eventSeoSchema } from './seoConfigSchema'
import {
  getEventSeoAction,
  updateEventPageSeoAction,
} from 'src/redux/actions/workshopEvent'

interface IAboutUsPageSeoProps {
  activeTab: string
}

export const EventSeoForPage = ({ activeTab }: IAboutUsPageSeoProps) => {
  const dispatch = useAppDispatch()

  const configSeo = useAppSelector((state) => state.workshopEvents.eventPageSeo)

  const isGetSeoActionLoading = useAppSelector(
    (state) => state.workshopEvents?.loadings[thunkActionLoading.GET_EVENT_SEO]
  )

  const isUpdating = useAppSelector(
    (state) =>
      state.workshopEvents?.loadings[thunkActionLoading.UPDATE_EVENT_SEO]
  )

  const { handleSubmit, control, setValue, getValues } =
    useForm<IEventSeoSchema>({
      defaultValues: {
        metaTitle: '',
        metaDescription: '',
        metaImage: '',
        canonical: '',
        schemaMarkup: 'schema mark up',
        keywords: '',
      },
      resolver: zodResolver(eventSeoSchema),
      mode: 'onSubmit',
      reValidateMode: 'onChange',
    })

  const onSubmit = async (data: IEventSeoSchema) => {
    try {
      const response = await dispatch(updateEventPageSeoAction(data)).unwrap()

      if (response.success) {
        message.success(response?.message ?? '')
      }
    } catch (error: any) {
      message.error(error?.message ?? '')
    }
  }

  const handleClickSave = () => {
    handleSubmit(onSubmit)()
  }

  useEffect(() => {
    if (activeTab === EWorkshopAndEventPageTabs.SEO_CONFIG) {
      const getEvolvePageSeo = async () => {
        try {
          dispatch(getEventSeoAction()).unwrap()
        } catch (error: any) {
          message.error(error?.message ?? '')
        }
      }
      getEvolvePageSeo()
    }
  }, [activeTab])

  useEffect(() => {
    if (configSeo) {
      setValue('metaTitle', configSeo?.metaData?.metaTitle || '')
      setValue('metaDescription', configSeo?.metaData?.metaDescription || '')
      setValue('metaImage', configSeo?.metaData?.metaImage || '')
      setValue('canonical', configSeo?.metaData?.canonical || '')
      setValue('keywords', configSeo?.metaData?.keywords || '')
    }
  }, [configSeo])
  return (
    <Fragment>
      {isGetSeoActionLoading ? (
        <>
          <Skeleton
            paragraph={{ rows: 4 }}
            style={{
              marginTop: 10,
            }}
          />
        </>
      ) : (
        <div className="bg-white">
          <MetaTab
            activeTab={activeTab}
            control={control}
            getValues={getValues}
            setValue={setValue}
            isShowSelectMedia
            category={EMediaCategory.CONTENT}
          />

          <div className="term-policy-action mr-5 pb-5 flex items-center justify-end gap-6">
            <Button
              type="primary"
              size="small"
              id="blog-form"
              onClick={() => {
                handleClickSave()
              }}
              loading={isUpdating || isGetSeoActionLoading}
            >
              Save
            </Button>
          </div>
        </div>
      )}
    </Fragment>
  )
}
